import Admin from "./Pages/Admin";
import AdminProfileSetting from "./Pages/AdminProfileSettings";
import AdminPasswordRequest from "./Pages/AdminPasswordRequestPage";
import AdminDeleteAccount from "./Pages/AdminDeleteAccount";
import AdminMerchant from "./Pages/AdminMerchant";
import MerchantAccount from "./Pages/MerchantAccount";
import MerchantAccountInActive from "./Pages/MerchantAccountInActive";
import SendEmailMerchant from "./Pages/SendEmailMerchant";
import SuperAdminCreateAdmin from "./Pages/SuperAdminCreateAdmin";
import AdminProfileAvtive from "./Pages/AdminProfileActive";
import AdminProfileInActive from "./Pages/AdminProfileInActive";
import PaymentHistoryPage from "./Pages/PaymentHistoryPage";
import PaymentBehalfMerchant from "./Pages/PaymentBehalfMerchant";
import AdminCreateBlog from "./Pages/AdminCreateBlog";
import SuperAdmin from "./Pages/SuperAdminPage";
import { Routes, Route, Outlet, Link, BrowserRouter } from "react-router-dom";

function App() {
  return (
    <div>
      <BrowserRouter>
      <Routes>
      <Route path="/" element={<Admin />} />
      <Route path="/admin-profile-setting" element={<AdminProfileSetting />} />
      <Route path="/admin-password-request" element={<AdminPasswordRequest />} />
      <Route path="/admin-delete-account" element={<AdminDeleteAccount />} />
      <Route path="/admin-merchant" element={<AdminMerchant />} />
      <Route path="/merchant-account" element={<MerchantAccount />} />
      <Route path="/merchant-in-active" element={<MerchantAccountInActive />} />
      <Route path="/merchant-send-email" element={<SendEmailMerchant />} />
      <Route path="/create-admin" element={<SuperAdminCreateAdmin />} />
      <Route path="/admin-profile-active" element={<AdminProfileAvtive />} />
      <Route path="/admin-profile-in-active" element={<AdminProfileInActive />} />
      <Route path="/payment-history" element={<PaymentHistoryPage />} />
      <Route path="/payment-behalf-merchant" element={<PaymentBehalfMerchant />} />
      <Route path="/admin-create-blog" element={<AdminCreateBlog />} />
      <Route path="/super-admin" element={<SuperAdmin />} />
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
